export enum PositionCategoryModalNames {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
}